import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react"; // Icon for open/close sidebar
import adminLogo from "./AdminImage/logo-light-icon.png";
import config from "../../function/config";
import axios from "axios";
import admin from "./AdminImage/user3jpeg.jpeg";
import { motion } from "framer-motion";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import EarningsAreaChart from "./AdminImage/EarningsAreaChart";

export default function AllUsers() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [date, setDate] = useState(new Date());
  const earnings = [3000, 4000, 5000, 7000, 6000, 8000, 9000, 12000, 11000, 15000, 14000, 16000];

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200); // Check screen size

  const toggleDropdown = (id) => {
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if clicking the same dropdown
    } else {
      setOpenDropdown(id); // Open the clicked dropdown
    }
  };

  const [allShips, setallShips] = useState([]);
  const [allCat, setallCat] = useState([]);
  const [allSubCat, setallsubCat] = useState([]);
  const [allAm, setallAm] = useState([]);
  const [allImages,setAllImages] = useState([])
  const [selectedShip, setSelectedShip] = useState(null); // State for selected ship

  const [allShipsReg, setallShipsReg] = useState([]);
const [newShip, setNewShip] = useState(
  JSON.parse(localStorage.getItem("newShip")) || false
);
const [prevShipCount, setPrevShipCount] = useState(
  JSON.parse(localStorage.getItem("prevShipCount")) || 0
);

const [allChart,setAllChart] = useState([])

useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShipForCharter`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setAllChart(res1.data.data.reverse());
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);

useEffect(() => {
  async function fetchData() {
    try {
      const res1 = await axios.get(
        `${config.base_url}/api/HappyMarineShipping/viewShipForSale`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res1.data.status === 200) {
        const fetchedShips = res1.data.data;
        const currentShipCount = fetchedShips.length;

        // Check if a new ship was added AFTER the last seen count
        if (currentShipCount > prevShipCount) {
          setNewShip(true);
          localStorage.setItem("newShip", JSON.stringify(true));
          localStorage.setItem("prevShipCount", JSON.stringify(currentShipCount));
        }

        setallShipsReg(fetchedShips);
      }
    } catch (error) {
      console.log(error);
    }
  }

  fetchData();

  // Polling every 5 seconds
  const interval = setInterval(fetchData, 5000);

  return () => clearInterval(interval);
}, [prevShipCount]); // Only depend on prevShipCount to avoid unnecessary updates

const handleView = () => {
  setNewShip(false);
  localStorage.setItem("newShip", JSON.stringify(false));
  setPrevShipCount(allShipsReg.length);
  localStorage.setItem("prevShipCount", JSON.stringify(allShipsReg.length));
};

const [allEq,setAllEq] = useState([])
useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShipForEquipments`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setAllEq(res1.data.data.reverse());
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);



  useEffect(() => {
    async function fetchdata() {
      try {
        const res3 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/ship_images`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            }
          }
        );
        if (res3.data.status === 200) {
          console.log("Images :",res3);
          setAllImages(res3.data.data.reverse());
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);

  // fetch ship data
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShip`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setallShips(res1.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewCategory`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res2.data.status === 200) {
          console.log(res2);
          setallCat(res2.data.data.reverse());
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);

  // sub category
  useEffect(() => {
    async function fetchdata() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewSubCategory`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res2.data.status === 200) {
          console.log(res2);
          setallsubCat(res2.data.data.reverse());
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);

  // amenities
  useEffect(() => {
    async function fetchdata() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewAmenities`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res2.data.status === 200) {
          console.log(res2);
          setallAm(res2.data.data.reverse());
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1200);
      if (window.innerWidth <= 1200) {
        setIsSidebarOpen(false); // Hide sidebar by default on small screens
        setOpenDropdown(false);
      }
    };

    handleResize(); // Call on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown
  const toggleDropdownprofile = (e) => {
    e.stopPropagation(); // Prevent click event from bubbling
    setIsOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [hasNotification, setHasNotification] = useState(true);
  const [isOpennoti, setIsOpennoti] = useState(false);
  const toggleDropdownNotification = (e) => {
    e.stopPropagation();
    setIsOpennoti((prev) => !prev);

    // Remove notification dot when opening dropdown
    if (hasNotification) {
      setHasNotification(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpennoti(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);


  const navigate = useNavigate()
  
  const recentShip = allShips.length > 0 ? allShips[0] : null;
  const recentShipImage = allImages.length > 0 ? allImages[0] : null;

  
  const displayedShipimage = selectedShip || (allImages.length > 0 ? allImages[0] : null);

  // Add an identifier to distinguish Admin Ships and Customer Ships
const filteredAllShipsReg = allShipsReg
.filter((ship) => ship.is_allow)
.map((ship) => ({ ...ship, isFromReg: true })); // Mark as from RegisterShipForSale

const allShipsWithFlag = allShips.map((ship) => ({ ...ship, isFromReg: false })); // Mark as Admin Ship

// Merge and sort ships by created_at (latest first)
const sortedData = [...allShipsWithFlag, ...filteredAllShipsReg].sort(
(a, b) => new Date(b.created_at) - new Date(a.created_at)
);


const displayedShip = selectedShip || (sortedData.length > 0 ? sortedData[0] : null);

const [allImagesReg,setAllImagesReg] = useState([])
  
    useEffect(() => {
      async function fetchdata() {
        try {
          const res3 = await axios.get(
            `${config.base_url}/api/HappyMarineShipping/ship_images_Reg`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              }
            }
          );
          if (res3.data.status === 200) {
            console.log("Images :",res3);
            setAllImagesReg(res3.data.data);
          } else {
            console.log("error");
          }
        } catch (error) {
          console.log(error);
        }
      }
      fetchdata();
    }, [config.base_url]);

      const [users, setUser] = useState([]);
       const token = localStorage.getItem("token");
    useEffect(() => {
  async function fetchdata() {
    try {
      const res2 = await axios.get(
        `${config.base_url}/api/HappyMarineShipping/alluser`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        }
      );

      console.log("API response:", res2.data);

      if (res2.data.Status === 200) {
        const userData = res2.data.data.reverse();  // ✅ Extract user object
        setUser(userData);

      } else {
        console.log(res2);
      }
    } catch (error) {
      console.log(error);
    }
  }
  fetchdata();
}, [token]);


  return (
    <div className="h-screen flex flex-col bg-gray-100">
      {/* Navbar - Full Width, Above Sidebar */}
      <nav className="bg-[#123d5f] p-4 flex items-center shadow-md w-full transition-all duration-300">
        {/* Left Side - Admin Logo & Title */}
        <div className="flex items-center gap-2">
          <img src={adminLogo} className="w-[35px] h-[35px]" alt="Admin Logo" />
          {isSidebarOpen && (
            <h1 className="text-lg font-bold text-white">Admin</h1>
          )}
        </div>

         {/* Menu Button (Moves on Sidebar Toggle) */}
                <button
                  onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                  className={`absolute xm:hidden transition-all duration-300 text-white ${
                    isSidebarOpen ? "left-60" : "left-16"
                  }`}
                >
                  <Menu size={28} />
                </button>

             {/* mobile screen menu button */}
                    <button
                      onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                      className={`absolute xm:block hidden transition-all duration-300 text-white ${
                        isSidebarOpen ? "left-32" : "left-16"
                      }`}
                    >
                      <Menu size={28} />
                    </button>

                    

        {/* Admin Profile (Right Side) */}
        <div className="relative ml-auto pr-5 flex items-center gap-20">
          {/* notification */}
          <div className="relative">
            <div>
                                  <Link className="bg-gray-200 p-2 rounded" to={'/admin/users'}>See All Users</Link>
                                </div>
            {/* Envelope Icon with Blinking Dot */}
            {/* <div className="cursor-pointer relative" onClick={toggleDropdownNotification}>
              <i className="fa-regular fa-envelope text-[28px] text-gray-500"></i>

              
            </div> */}

            {/* Notification Dropdown */}
            {/* {isOpennoti && (
              <div
                ref={dropdownRef}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-48 py-2 origin-top transition-transform duration-300 scale-y-100 opacity-100"
                style={{ transformOrigin: "top" }}
              >
                <ul className="text-gray-700">
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    Check Notifications
                  </li>
                </ul>
              </div>
            )} */}
          </div>
          {/* Admin Image */}
          <div>
            <img
              src={admin} // Replace with {admin} if using a variable
              className="rounded-full w-[35px] cursor-pointer"
              alt="admin"
              onClick={toggleDropdownprofile}
            />
            {/* Dropdown */}
            {isOpen && (
              <motion.div
                ref={dropdownRef}
                initial={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                animate={{ opacity: 1, rotateX: 0, scale: 1 }}
                exit={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-40 py-2 origin-top transform"
              >
                <ul className="text-gray-700">
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link to={'/admin/profile'}>Profile</Link>
                  </li>
                  <li className="px-3 py-2 hover:bg-gray-100 cursor-pointer">
                  <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                  </li>
                </ul>
              </motion.div>
            )}
          </div>
        </div>
      </nav>

      {/* Sidebar & Content Wrapper */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <div
          className={`${
            isSidebarOpen ? "w-60 overflow-y-auto" : "w-16"
          }  bg-white xl:hidden text-[#8D97AD] shadow-xl transition-all duration-300  max-h-screen `}
        >
          <ul className="mt-10 flex flex-col gap-3 ">
            {/* Dashboard */}
            <li className="px-4 py-2 text-lg   flex items-center">
              <i className="fa-solid fa-gauge mr-3"></i>
              {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
            </li>

            {isSidebarOpen && <div className="px-5 mt-2 w-[75%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}

            {/* Ship For Sale Dropdown */}
            <li className="px-2  text-lg  flex flex-col  relative">
              <div
                className="flex items-center  justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
              >
                <div className="flex items-center  gap-2 hover:text-[#00c292]">
                 <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Ship For Sale</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 1 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 1
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-2  text-lg flex flex-col relative">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(2)} // Toggle Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Ship For Charter</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>
              {!isSidebarOpen && openDropdown === 2 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 2
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

             <li className="px-2  text-lg flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                   <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Open Cargo </span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 3 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to='/admin/addcargo' >Add Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to='/admin/viewCargo' >View Cargo</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 3
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to='/admin/addcargo' >Add Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                       <Link to='/admin/viewCargo' >View Cargo</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-2  text-lg flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                   <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Supply Equipments </span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 4 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 4
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

              {isSidebarOpen && <div className="px-5 mt-2 w-[75%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Approvals</h1></div>}
              {isSidebarOpen && <ul className="px-2  text-lg flex flex-col relative group">
         <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
          <Link
            to="/admin/shipforsale"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Ships For Sale
          </Link>
          {newShip && (
            <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
              New
            </span>
          )}
        </li>
        
         <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
          <Link
            to="/admin/shipforCharterApp"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Ship For Charter
          </Link>
          
        </li>
        
         <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
          <Link
            to='/admin/LogisticsAppr'
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Open Cargo
          </Link>
          
        </li>
        
         <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
          <Link
            to="/admin/shipforEqApp"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Supply Equipments
          </Link>
        </li>
        
        
      </ul>}


            

            {/* Settings Dropdown */}
            <li className="px-3 py-2 text-lg flex flex-col relative group">
              <div
                className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                onClick={() => toggleDropdown(6)}
              >
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-gear"></i>
                  {isSidebarOpen && <span>Settings</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {/* Hover Dropdown (Closed Sidebar) */}
              {!isSidebarOpen && openDropdown === 6 && (
                <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                  <ul>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-4 py-2 hover:bg-gray-100">
                    <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Click Dropdown (Open Sidebar) */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 6
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-3 py-1 hover:text-[#00c292]">
                     <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
          </ul>
        </div>

        {/* mobile screen sidebar */}

        <div
          className={`fixed hidden   xl:block h-full bg-white text-[#8D97AD] shadow-xl transition-all duration-300 ${
            isMobile
              ? isSidebarOpen
                ? "w-full  translate-x-0" // Open in full width on mobile
                : "-translate-x-full w-0" // Hide sidebar on mobile
              : isSidebarOpen
              ? "w-60 translate-x-0" // Open normally on desktop
              : "w-0" // Hide sidebar on desktop
          }`}
        >
          <ul className="mt-10 flex  flex-col gap-3 ">
            {/* Dashboard */}
            <li className={`px-4 py-2 text-lg text-[#00c292] ${
                isSidebarOpen ? "border-l-4 border-[#00c292]" : "border-none"
              }  flex items-center`}>
              {isSidebarOpen && <i className="fa-solid fa-gauge mr-3"></i>}
              {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
            </li>
               {isSidebarOpen && <div className="px-5  w-[50%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}
            {/* Ship For Sale Dropdown */}
            <li
              className={`px-2  text-lg  flex flex-col  relative`}
            >
              <div
                className="flex items-center  justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
              >
                <div className="flex items-center  gap-2 hover:text-[#00c292]">
                  {isSidebarOpen && <h1 className="text-xl text-center font-semibold">-</h1>}
                  {isSidebarOpen && <span>Ship For Sale</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 1 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 1
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-3  text-lg flex flex-col relative">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(2)} // Toggle Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                  {isSidebarOpen && <span>Ship For Charter</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>
              {!isSidebarOpen && openDropdown === 2 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 2
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

             <li className="px-3  text-lg flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                  {isSidebarOpen && <span>Open Cargo</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 3 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to='/admin/addcargo'>Add Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                       <Link to='/admin/viewCargo' >View Cargo</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 3
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to='/admin/addcargo'>Add Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                       <Link to='/admin/viewCargo' >View Cargo</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-3  text-lg flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                  {isSidebarOpen && <span>Supply Equipments</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 4 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 4
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-3 text-lg flex flex-col relative group">
  {/* Clickable Div */}
 {isSidebarOpen && <div className="px-5  w-[50%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Approvals</h1></div>}

              {isSidebarOpen && <ul className="px-2 py-2  text-lg flex gap-3
               flex-col relative group">
         <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
          <Link
            to="/admin/shipforsale"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Ships For Sale
          </Link>
          {newShip && (
            <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
              New
            </span>
          )}
        </li>
        
         <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
          <Link
            to="/admin/shipforCharterApp"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Ship For Charter
          </Link>
          
        </li>
        
         <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
          <Link
            to='/admin/LogisticsAppr'
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Open Cargo
          </Link>
          
        </li>
        
         <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
          <Link
            to="/admin/shipforEqApp"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Supply Equipments
          </Link>
        </li>
        
        
      </ul>
  }

  {/* Click Dropdown (For open sidebar) */}
  {isSidebarOpen && (
    <div
      className={`ml-6 mt-2 transition-all duration-300 ${
        openDropdown === 5
          ? "max-h-48 opacity-100 "
          : "max-h-0 opacity-0 overflow-hidden"
      }`}
    >
     <ul>
         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
          <Link
            to="/admin/shipforsale"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Ships For Sale
          </Link>
          {newShip && (
            <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
              New
            </span>
          )}
        </li>
        
         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
          <Link
            to="/admin/shipforCharterApp"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Ship For Charter
          </Link>
          
        </li>
        
         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
          <Link
            to='/admin/LogisticsAppr'
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Open Cargo
          </Link>
          
        </li>
        
         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
          <Link
            to="/admin/shipforEqApp"
            onClick={() => handleView()} // Ensure it runs before navigation
          >
           - Supply Equipments
          </Link>
        </li>
        
        
      </ul>
    </div>
  )}
</li>


            {/* Settings Dropdown */}
            <li className="px-3 py-2 text-lg flex flex-col relative group">
              <div
                className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                onClick={() => toggleDropdown(6)}
              >
                <div className="flex items-center gap-2">
                  {isSidebarOpen && <i className="fa-solid fa-gear"></i>}
                  {isSidebarOpen && <span>Settings</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {/* Hover Dropdown (Closed Sidebar) */}
              {!isSidebarOpen && openDropdown === 6 && (
                <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                  <ul>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-3 py-1 hover:text-[#00c292]">
                     <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Click Dropdown (Open Sidebar) */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 6
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-3 py-1 hover:text-[#00c292]">
                     <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
          </ul>
        </div>

        {/* Main Content */}
     <div className="flex-1 overflow-y-auto py-4">
       <div className="bg-white  shadow-sm text-xl w-full p-5">
                <div className="flex justify-between items-center">
                    <h1>Registered user Details</h1>
                    <div className="flex text-sm gap-2">
                     <Link to={'/admin/users'}>Home</Link> <span>/</span>
                     <p className="text-[#00c292]">Registered User Details</p>
                    </div>
                  </div>
                </div>
         <div className="p-5">
  <div className="bg-white shadow-md rounded-lg w-full overflow-x-auto mt-5">
    <table className="min-w-max border border-gray-200">
      <thead className="bg-gray-100 border-b">
        <tr>
          <th className="px-2 py-3 text-left text-sm font-semibold text-gray-600">#</th>
          <th className="px-2 py-3 text-left text-sm font-semibold text-gray-600">Image</th>
          <th className="px-2 py-3 text-left text-sm font-semibold text-gray-600">Username</th>
          <th className="px-2 py-3 text-left text-sm font-semibold text-gray-600">First Name</th>
          <th className="px-2 py-3 text-left text-sm font-semibold text-gray-600">Last Name</th>
          <th className="px-2 py-3 text-left text-sm font-semibold text-gray-600">Email</th>
          <th className="px-2 py-3 text-left text-sm font-semibold text-gray-600">Phone</th>
          <th className="px-2 py-2 text-left text-sm font-semibold text-gray-600">Company Name</th>
          <th className="px-2 py-3 text-left text-sm font-semibold text-gray-600">Address</th>
          <th className="px-2 py-3 text-left text-sm font-semibold text-gray-600">Registered At</th>
        </tr>
      </thead>

      <tbody>
        {users.length > 0 ? (
          users.map((user, index) => (
            <tr key={user.id} className="border-b hover:bg-gray-50">
              <td className="px-2 py-3 text-sm">{index + 1}</td>

              <td className="px-2 py-3 text-sm">
                <img
                  src={user.image ? `${config.base_url}${user.image}` : "/default-user.png"}
                  alt="User"
                  className="w-12 h-12 rounded-full object-cover"
                />
              </td>

              <td className="px-2 py-3 text-sm capitalize">{user.username || "None"}</td>
              <td className="px-2 py-3 text-sm capitalize">{user.first_name || "No Name"}</td>
              <td className="px-2 py-3 text-sm capitalize">{user.last_name || "No Name"}</td>
              <td className="px-2 py-3 text-sm">{user.email}</td>
              <td className="px-2 py-3 text-sm">{user.phone || "-"}</td>
              <td className="px-2 py-2 text-sm">{user.company_name || "-"}</td>
              <td className="px-2 py-3 text-sm">{user.address || "-"}</td>

              <td className="px-2 py-3 text-sm">
                {new Date(user.date_joined).toLocaleString("en-US", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true
                })}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="10" className="text-center py-4 text-gray-500 text-sm">
              No users found
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>

     </div>

      </div>
    </div>
  );
}
